import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";

function ContactUsList() {
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();
  const [enquiry, setEnquiry] = useState([]);
  const [loading, setloading] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getEnquiry();
  }, []);

  const getEnquiry = () => {
    axios.get(URL_API + "contacts").then((response) => {
      if (response.data.status === 200) {
        setEnquiry(response.data.contacts);
      }
    });
  };

  const destroyEnquiry = (id) => {
    axios
      .post(URL_API + `contacts/destroy/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          history.push("/admin/contact-us");
          toast.success("Contact Us Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getEnquiry();
        }
      });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Contact Us</CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <a href={`/admin/maker/create`}>
                  {/* <strong>Add Maker + </strong> */}
                </a>
              </div>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th >Name</th>
                      <th style={{ width: "30px" }}>email</th>
                      <th>phone</th>
                      <th>Message</th>
                      <th>Created At</th>
                      <th>Action</th>
                      {/* <th className="text-right">Salary</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {enquiry.map(
                      (enqList, index) => {
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td style={{marginRight:"0px"}}>{enqList?.name}</td>
                            <td>{enqList?.email}</td>
                            <td>{enqList?.phone}</td>
                            <td>{enqList?.message}</td>
                            <td>
                              {moment(enqList?.created_at).format(" DD MMMM,YYYY")}
                            </td>

                            <td>
                              {/* <a style={{color:"#77ac54"}} href={`article/detail/${enqList.id}`}>
                                  <i class="fas fa-eye fa-lg"></i>
                                </a>
                                &nbsp;&nbsp; */}
                              {/* <a href={`maker/edit/${enqList.id}`}>
                                <i class="far fa-edit fa-lg"></i>
                              </a> */}
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <a
                                style={{ color: "red" }}
                                onClick={() => destroyEnquiry(enqList.id)}
                              >
                                <i class="fas fa-trash-alt fa-lg"></i>
                              </a>
                            </td>
                          </tr>
                        );
                      }
                      // )
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ContactUsList;
